import { Color, Flex, Space, Text, Tooltip } from '@billy/design-system'
import { ReactElement, useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import { Avatar } from '../Avatar'
import { Size } from '../Avatar/types/size'
import { MAX_VISIBLE } from './constants/maxVisible'
import { AccessGroupPopover } from './elements/AccessGroupPopover'
import * as Styled from './styles'
import { getAvatarColor } from './utils/getAvatarColor'

export interface User {
  id: string
  name: string
}

export interface AccessGroupProps {
  label?: string
  size?: Size
  users: User[]
}

export const AccessGroup = ({ label, users, size = 'm' }: AccessGroupProps): ReactElement => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)
  const overflowRef = useRef<HTMLDivElement>(null)

  useClickAway(overflowRef, () => setIsPopoverOpen(false))

  const handleOverflowClick = () => setIsPopoverOpen((prev) => !prev)

  const visibleUsers = users.slice(0, MAX_VISIBLE)
  const hiddenCount = users.length - MAX_VISIBLE

  return (
    <Flex alignItems="center">
      {label && (
        <>
          <Text variant="bodyMD" color={Color.Grey500}>
            {label}:
          </Text>
          <Space horizontal size="s16" />
        </>
      )}
      {visibleUsers.map((user, index) => (
        <Styled.AvatarItem key={user.id} zIndex={index + 1}>
          <Tooltip label={user.name} placement="bottom">
            <Avatar noMargin name={user.name} backgroundColor={getAvatarColor(index)} size={size} />
          </Tooltip>
        </Styled.AvatarItem>
      ))}

      {hiddenCount > 0 && (
        <Styled.AvatarItem ref={overflowRef} zIndex={MAX_VISIBLE + 1}>
          <Styled.OverflowButton onClick={handleOverflowClick}>
            <Avatar noMargin initials={`+${hiddenCount}`} backgroundColor={getAvatarColor(MAX_VISIBLE)} size={size} />
          </Styled.OverflowButton>
          {isPopoverOpen && <AccessGroupPopover users={users} />}
        </Styled.AvatarItem>
      )}
    </Flex>
  )
}
